import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Repository } from 'typeorm';
import { AllPostTypesResponseModel } from './dto/all-post-types-response.model';
import { PostTypeResponseModel } from './dto/post-type-response.model';
import { PostTypeDTO } from './dto/post-type.dto';
import { PostTypeStatusDTO } from './dto/post-type.request';
import { PostTypeEntity } from './post-type.entity';

@Injectable()
export class PostTypeService {
    constructor(
        @InjectRepository(PostTypeEntity)
        private postTypeRepository: Repository<PostTypeEntity>,
    ) {}

    async createPostType(queryParams, postTypeDto: PostTypeDTO, request: Request): Promise<PostTypeResponseModel> {
        const response = new PostTypeResponseModel();
        try {
            const postTypeExists = await this.getPostTypeWithoutRelations(postTypeDto.postType);
            if(postTypeExists) {
                throw new ErrorResponse(11104, 'Post Type already exists');
            } else {
                if(queryParams.apiVersion == 1) {
                    const savedPostType = await this.postTypeRepository.save(postTypeDto);
                    if(savedPostType) {
                        response.status = true;
                        response.data   = savedPostType;
                        response.statusCode = 50000;
                        response.internalMessage = 'Post Type Created Successfully';
                        response.intlCode = 11100;
                    } else { 
                        throw new ErrorResponse(11106, 'Post Type Not Created')
                    }
                } else {
                    const savedPostType = await this.postTypeRepository.save(postTypeDto);
                    if(savedPostType) {
                        response.status = true;
                        response.data   = savedPostType;
                        response.statusCode = 50000;
                        response.internalMessage = 'Post Type Created Successfully';
                        response.intlCode = 11100;
                    } else { 
                        throw new ErrorResponse(11106, 'Post Type Not Created')
                    }
                }
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

    async getPostTypeWithoutRelations(postType: string): Promise<PostTypeEntity> {
        const postTypeResponse = await this.postTypeRepository.findOne({
            where: {postType: postType, status: true},
        });
        if(postTypeResponse) {
            return postTypeResponse;
        } else {
            return null;
        }
    }

    async updatePostType(queryParams, postTypeDto: PostTypeDTO, request:Request): Promise<PostTypeResponseModel> {
        const response = new PostTypeResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                const updatePostType = await this.postTypeRepository.update(postTypeDto.Id, postTypeDto);
                const updatedData = await this.postTypeRepository.findOne({
                    where:{Id:postTypeDto.Id}
                });
                if(updatePostType) {
                    response.status = true;
                    response.data   = updatedData;
                    response.statusCode = 50000;
                    response.internalMessage = 'Post Type updated successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Post Type Update Failed')
                }
            } else {
                const updatePostType = await this.postTypeRepository.update(postTypeDto.Id, postTypeDto);
                const updatedData = await this.postTypeRepository.findOne({
                    where:{Id:postTypeDto.Id}
                });
                if(updatePostType) {
                    response.status = true;
                    response.data   = updatedData;
                    response.statusCode = 50000;
                    response.internalMessage = 'Post Type updated successfully';
                    response.intlCode = 11101;
                } else {
                    throw new ErrorResponse(99998, 'Post Type Update Failed')
                }
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

    async getActivePostTypes(queryParams): Promise<AllPostTypesResponseModel> {
        const response = new AllPostTypesResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                const activePostTypes = await this.postTypeRepository.find({
                    where: {status: true},
                    order: { createdAt: 'DESC' }
                });
                if(activePostTypes) {
                    response.status = true;
                    response.data = activePostTypes;
                    response.statusCode = 50000;
                    response.internalMessage = 'data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
            } else {
                const activePostTypes = await this.postTypeRepository.find({
                    where: {status: true},
                    order: { createdAt: 'DESC' }
                });
                if(activePostTypes) {
                    response.status = true;
                    response.data = activePostTypes;
                    response.statusCode = 50000;
                    response.internalMessage = 'data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

    async updatePostTypeStatus(queryParams, postTypeStatusDto: PostTypeStatusDTO, request:Request): Promise<PostTypeResponseModel> {
        const response = new PostTypeResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                const updatePostTypeStatus = await this.postTypeRepository.update(postTypeStatusDto.Id, postTypeStatusDto);
                const updatedData = await this.postTypeRepository.findOne({
                    where:{Id:postTypeStatusDto.Id}
                });
                if(updatePostTypeStatus) {
                    response.status = true;
                    response.data   = updatedData;
                    response.statusCode = 50000;
                    response.internalMessage = 'Post Type Status updated successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Post Type Status Update Failed')
                }
            } else {
                const updatePostTypeStatus = await this.postTypeRepository.update(postTypeStatusDto.Id, postTypeStatusDto);
                const updatedData = await this.postTypeRepository.findOne({
                    where:{Id:postTypeStatusDto.Id}
                });
                if(updatePostTypeStatus) {
                    response.status = true;
                    response.data   = updatedData;
                    response.statusCode = 50000;
                    response.internalMessage = 'Post Type Status updated successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Post Type Status Update Failed')
                }
            }
            return response;
        } catch (error) {
            throw error;
        }
    }
}
